import React, { Fragment } from 'react';
import Zuck from "zuck.js";
import { PlusCircleOutlined } from '@ant-design/icons';
import { Tooltip, Button, Col } from "antd";

import { SERVER_BASE_URL } from "../../helpers/constants";
import { toTimestamp } from "../../helpers";
import AddStories from "./AddStories"

import './stories.css';

const get = function (array, what) {
  if (array) {
    return array[what] || '';
  } else {
    return '';
  }
};


class Stories extends React.Component {
  constructor(props) {
    super(props);

    this.storiesElement = null;
    this.storiesApi = null;


    this.state = {
      stories: [
        ...this.props.stories.map((story, key) => {
          const storyZuck = Zuck.buildTimelineItem(
            story.name,
            story.photo,
            story.name,
            '',
            Date.now(story.lastUpdated),
            [
              ...story.items.map(item => {
                return ["ramon-1", item.fileType === "image" ? "photo" : item.fileType, item.fileType === "image" ? 3 : item.length, process.env.REACT_APP_BASE_URL + item.src, process.env.REACT_APP_BASE_URL + item.src, '', false, item.seen, toTimestamp(item.time)]
              })
            ]
          )
          let storiesSeen = localStorage.getItem('zuck-stories-react-seenItems');
          if (!storiesSeen) storiesSeen = '{}'
          storiesSeen = JSON.parse(storiesSeen)
          storiesSeen[key] = story.seen
          storiesSeen = JSON.stringify(storiesSeen)
          localStorage.setItem("zuck-stories-react-seenItems", storiesSeen)
          if (storyZuck.length > 0) storyZuck.items[storyZuck.items.length - 1].seen = false
          return storyZuck;
        })
      ]
    }
  }

  componentDidMount() {
    const { stories, storySeenFun } = this.props
    this.storiesApi = new Zuck(this.storiesElement, {
      paginationArrows: false,
      skin: 'snapgram',      // container class
      avatars: true,         // shows user photo instead of last story item preview
      list: false,           // displays a timeline instead of carousel
      openEffect: true,      // enables effect when opening story
      cubeEffect: false,     // enables the 3d cube effect when sliding story
      autoFullScreen: false, // enables fullscreen on mobile browsers
      backButton: true,      // adds a back button to close the story viewer
      backNative: false,     // uses window history to enable back button on browsers/android
      previousTap: true,     // use 1/3 of the screen to navigate to previous item when tap the story
      reactive: true,        // set true if you use frameworks like React to control the timeline (see react.sample.html)
      rtl: false,
      stories: this.state.stories,
      callbacks: {
        onDataUpdate: function (currentState, callback) {
          this.setState(state => {
            state.stories = currentState;
            return state;
          }, () => {
            callback();
          });
        }.bind(this),
        async onView(storyId) {
          try {
            const storyItems = stories[storyId].items;
            for await (let item of storyItems) {
              await storySeenFun({ variables: { id: item.id } });
            }
          } catch (err) {
            console.log(err)
          }

        },
      },
      template: {
        viewerItem(storyData, currentStoryItem) {
          const index = stories.findIndex(story => {
            return story.photo === storyData.photo.split(SERVER_BASE_URL)[1]
          })
          return `<div class="story-viewer">
                    <div class="head">
                      <div class="left">
                        <a class="back">&lsaquo;</a>
                        <span class="item-preview">
                          <img lazy="eager" class="profilePhoto" src="${get(storyData, 'photo')}" />
                        </span>

                        <div class="info">
                          ${stories[index] && stories[index].userProfileUrl ? `<a  href=${stories[index].userProfileUrl} class="name profile_url">${get(storyData, 'name')}</a>` : `<strong class="name">${get(storyData, 'name')}</strong>`}
                          <span class="time">${get(storyData, 'timeAgo')}</span>
                        </div>
                      </div>

                      <div class="right">
                        <span class="time">${get(currentStoryItem, 'timeAgo')}</span>
                        <span class="loading"></span>
                        <a class="close" tabIndex="2">&times;</a>
                      </div>
                    </div>

                    <div class="slides-pointers">
                      <div class="wrap"></div>
                    </div>

             <div class="slides-pagination">
                          <span class="previous">&lsaquo;</span>
                          <span class="next">&rsaquo;</span>
              </div>
            }
                  </div>`;
        },
      },
    });
  }

  render() {
    const timelineItems = []
    this.state.stories.forEach((story, storyId) => {
      const storyItems = [];

      story.items.forEach((storyItem) => {
        storyItems.push(
          <li key={storyItem.id} data-id={storyItem.id} data-time={storyItem.time} className={(storyItem.seen ? 'seen' : '')}>
            <a href={storyItem.src} data-type={storyItem.type} data-length={storyItem.length} data-link={storyItem.link} data-linkText={storyItem.linkText}>
              <img src={storyItem.preview} />
            </a>
          </li>
        );
      });

      let arrayFunc = story.seen ? 'push' : 'unshift';
      arrayFunc = story.name === 'Your story' ? 'unshift' : 'push'
      timelineItems[arrayFunc](
        <div className={(story.seen ? 'story seen' : 'story')} key={storyId} data-id={storyId} data-last-updated={story.lastUpdated} data-photo={story.photo.includes("stories") ? process.env.REACT_APP_BASE_URL + story.photo : SERVER_BASE_URL + story.photo}>
          <a className="item-link" href={story.link}>
            <span className="item-preview">
              <img src={story.photo} />
            </span>
            <span className="info" itemProp="author" itemScope="" itemType="http://schema.org/Person" onClick={() => this.props.history.push("/")}>
              <strong className="name" itemProp="name" style={{ cursor: "pointer" }} >{story.name}</strong>
              <span className="time">{story.lastUpdated}</span><br />
            </span>
          </a>
          <ul className="items">
            {storyItems}
          </ul>
        </div>
      );
    });

    return (
      <div>
        {this.props.showModalAddStory && <AddStories showModalAddStory={this.props.showModalAddStory} setShowModalAddStory={this.props.setShowModalAddStory} stories={this.props.stories} ReFetchStories={this.props.ReFetchStories} zuckStoriesApi={this.storiesApi} />}
        <div ref={node => this.storiesElement = node} id="stories-react" className="storiesWrapper">
          {timelineItems}
          {
            this.props.showAddButton && (
              <Col>
                <Tooltip placement="bottom" title={<span>Add new story</span>}> <Button onClick={() => this.props.setShowModalAddStory(true)} style={{ padding: "2px", marginLeft: "1rem" }} size="small" type="primary"><PlusCircleOutlined style={{ fontSize: "1.1rem" }} /> Add</Button></Tooltip>
              </Col>
            )
          }

        </div>
      </div>
    );
  }
}
export default Stories;